// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import PortfolioAnalysisBuildingsDatagrid from '@/features/energyxplorer/portfolio/components/datagrid/overview-datagrid/PortfolioAnalysisBuildingsDatagrid';
import PortfolioAnalysisDashboard from '@/features/energyxplorer/portfolio/components/datagrid/overview-datagrid/PortfolioAnalysisDashboard';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/overview/building',
)({
  component: RouteComponent,
  staticData: { crumb: 'glossary:buildingAnalysis' },
});

function RouteComponent() {
  return (
    <PortfolioAnalysisDashboard
      DatagridComponent={PortfolioAnalysisBuildingsDatagrid}
    />
  );
}
